import { useState } from 'react';
import { Card, Flex, Grid, GridItem, IconButton, Text } from '@chakra-ui/react';
import { InfoCol } from '@components/InfoCol';
import type { PhoneNumberType } from '@customTypes/customer';
import { formatPhoneNumber } from '@utils/formats';
import { MdOutlineReportProblem } from 'react-icons/md';
import { Tooltip } from '@components/ui/tooltip';
import ReportPhoneNumberDialog from './ReportPhoneNumberDialog';

type Props = {
  item: PhoneNumberType,
};

const PhoneNumberCard = ({ item }: Props) => {
  const [showReportPhoneNumberDialog, setShowReportPhoneNumberDialog] = useState(false);

  const valueTextColor = item.talks_with_customer === false
    ? 'red.500'
    : (
      item.has_whatsapp === false
        ? { _light: 'yellow.600', _dark: 'yellow.400' }
        : undefined
    );

  return (
    <Card.Root
      size="sm"
      variant="subtle"
      p={4}
      mb={5}
    >
      <Flex alignItems="center" >
        <Grid templateColumns="repeat(3, 1fr)" gap="4" flex="1">
          <GridItem colSpan={{ base: 3, md: 1 }}>
            <Flex gap={1} flexDirection="column">
              <Text fontSize="sm" color="text.muted" fontWeight={600}>Telefone</Text>
              <Text fontSize="md" color={valueTextColor} textDecoration={item.talks_with_customer === false ? 'line-through' : 'none'}>
                {formatPhoneNumber(item.phone_number)}
              </Text>
            </Flex>
          </GridItem>
          <GridItem colSpan={{ base: 3, md: 1 }}>
            <InfoCol
              label="Tem WhatsApp?"
              value={item.has_whatsapp ? 'Sim' : 'Não'}
              mb={0}
            />
          </GridItem>
          <GridItem colSpan={{ base: 3, md: 1 }}>
            <InfoCol
              label="Pertence ao cliente?"
              value={item.talks_with_customer ? 'Sim' : 'Não'}
              mb={0}
            />
          </GridItem>
        </Grid>
        <Tooltip content="Reportar número" showArrow>
          <IconButton
            variant="ghost"
            color="argos.fg"
            onClick={() => setShowReportPhoneNumberDialog(true)}
          >
            <MdOutlineReportProblem />
          </IconButton>
        </Tooltip>
      </Flex>

      {showReportPhoneNumberDialog && (
        <ReportPhoneNumberDialog
          handleClose={() => setShowReportPhoneNumberDialog(false)}
          item={item}
        />
      )}
    </Card.Root>
  )
};

export default PhoneNumberCard;
